<template>
    <div>
        <section class="page-title">
    <div class="center contato">
        <h1 class="the-title">Contato</h1>
        <p>Em caso de dúvidas, entre em contato conosco.</p>
    </div>
</section>
<div class="page-content center">
    <div class="row-contact">
        <div class="col">
            <p class="title"><i class="far fa-envelope"></i>E-mail</p>
            <p>comercial@primavida.com.br</p>
            <p class="title"><i class="fab fa-whatsapp"></i>Whatsapp </p>
            <span style="font-size: 18px; color: #09858b;" class="resumo">Beneficiário</span>
            <p>(21) 97164-0379</p>
            <span style="font-size: 18px; color: #09858b;" class="resumo">Parceiros/Gestores RH/DP</span>
            <p>(21) 99959-7339</p>
        </div>
        <div class="col-bigger">
            <p class="title"><i class="fas fa-phone"></i>Telefones</p>
            <div class="row-phones">
                <div class="item">
                    <p><strong>Sede RJ</strong><br>(21) 3299-4501</p>
                </div>
                <div class="item smaller">
                    <p><strong>Representante Autorizado MG</strong><br>(31) 3212-7657</p>
                    <p><strong>Representante Autorizado SP</strong><br>(11) 2307-2360 / (11) 2307-2365</p>
                    <p><strong>Representante Autorizado RO</strong><br>(69) 3536-0539</p>
                </div>
            </div>
        </div>
    </div>
    <!-- <router-link to="/contato" class="button-contact"><i class="far fa-comment-alt"></i>Entre em contato</router-link> -->
</div>
    </div>
</template>

<script>
export default {
    data(){
        return{
        }
    },
mounted : function(){
      this.$store.dispatch('ExibeToolbar')
      this.$store.dispatch('Logar')
    }

}
</script>

<style>

</style>
